import loadable from '@loadable/component';

import { readPersonalizationSettings } from '../user/storage/personalization';
import landingPageQuery from './query.graphql';

const LandingPage = loadable(() =>
  import(/* webpackChunkName: "landing-page" */ './landing-page')
);

LandingPage.graphQL = landingPageQuery;

LandingPage.loadOrder = [
  {
    rootCategories: true,
    campaignDeals: true,
    forumTopics: true,
    shopOfTheYear: true,
    featuredProducts: true,
  },
  {
    recommendations: true,
    newProductRecommendations: true,
    trendingProductRecommendations: true,
  },
];

LandingPage.variables = ({ marketCode, featureToggle }) => {
  const expertsEnabled = ['se'].includes(marketCode);
  const skip = featureToggle >= 1;

  return {
    personalizationExcludeCategories: readPersonalizationSettings().notInterestedIn.categories.map(
      category => +category.id
    ),
    experts: expertsEnabled,
    skip,
  };
};

export default LandingPage;
